import { useAppSelector } from "../../../../../stateManagement/hooks/redux"
import SmallLoader from "../../../../loaders/SmallLoader"

const objects_icon = require('../../../../../assets/images/icons/objects_icon.png')
const road_icon = require('../../../../../assets/images/icons/road_icon.png')
const direction_icon = require('../../../../../assets/images/icons/direction_icon.png')
const found_results_icon = require('../../../../../assets/images/icons/found_results_icon.png')

export function DefaultTableInfoContent() {
    const { roadName, pathName } = useAppSelector(state => state.pathsInfo.selectedPath) ?? {}
    const dataCount = useAppSelector(state => state.table.dataCount)
    const caption = useAppSelector(state => state.table.caption)

    return (
        <>
            <h5 className="table-info-head">В таблице отображены:</h5>
            <p>
                <img src={objects_icon} className="basic-image" /><strong>Объекты:</strong>
                <span className="table-info-value"> {caption}</span>
            </p>
            <p>
                <img src={road_icon} className="basic-image" /><strong>По дороге:</strong>
                <span className="table-info-value"> {roadName ? roadName : <SmallLoader iconColor="black" />}</span>
            </p>
            <p>
                <img src={direction_icon} className="basic-image" /><strong>Направление:</strong> 
                <span className="table-info-value"> {pathName ? pathName : <SmallLoader iconColor="black" />}</span>
            </p>
            <p>
                <img src={found_results_icon} className="basic-image" /><strong>Найдено объектов:</strong> 
                <span className="table-info-value"> {dataCount != null ? dataCount : <SmallLoader iconColor="black" />}</span>
            </p>
        </>
    )
}
